import axios from "../api/HttpClient"
import TokenHelper from "../helpers/TokenHelper";

export const NAMESPACE_LOCAL = "namespace_local";
export const NAMESPACE_REMOTE = "namespace_remote";

export async function getTranslations(language, namespace) {
  let translations = null;

  if (namespace === NAMESPACE_LOCAL) {
    translations = getLocalTranslations(language, namespace);
  }
  else if (namespace === NAMESPACE_REMOTE) {
    // Manual token preview, because useToken (=react hook) can not be used here
    const encodedToken = TokenHelper.getLocalAccessToken();
    if (encodedToken !== null && encodedToken !== "null") {
      translations = await getRemoteTranslations(language);
    }
    else {
      translations = null;
    }
  }

  return translations;
};

function getLocalTranslations(language, namespace) {
  let translations = null;

  try {
    const staticResults = window.STATIC_TRANSLATIONS[language][namespace];
    translations = translations || {};
    for (const key of Object.keys(staticResults)) {
      translations[key] = staticResults[key];
    }
  }
  catch (error) {
    console.error(error);
  }

  return translations;
}

async function getRemoteTranslations(language) {
  let translations = null;

  try {
    const response = await axios({
      method: "get",
      url: "/system-translations",
      params: { sprache: language }
    });

    if (response.status === 200) {
      const resultArray = response.data.data;
      if (resultArray != null && resultArray.length > 0) {
        translations = translations || {};
        for (const item of resultArray) {
          translations[item["KEY"]] = item["VALUE"];
        }
      }
    }
  } catch (error) {
    // May happen, if the user is not logged in (anymore)
    // console.error(error);
  }

  return translations;
}